import React from 'react';
import { Navigate } from 'react-router-dom';

/** PDF/print flow removed; send users to the report generator. */
export default function NumerologyReportPrintPage() {
  return <Navigate to="/numerology/report" replace />;
}
